import { conditionOperators, logicalOperators } from './RoutingRuleSetModel'

export const conditionOperatorOptions = [
    conditionOperators.equal,
    conditionOperators.equalOrGreater,
    conditionOperators.equalOrLesser,
    conditionOperators.in,
    conditionOperators.isAny,
    conditionOperators.isNone
]

export const logicalOperatorOptions = [
    logicalOperators.and,
    logicalOperators.or,
]

export type Channel = {
    name: string,
    brand: string
}

export type Brand = {
    name: string,
    channels: string[]
}

export type ArticleType = {
    name: string,
    articles: string[]
}

export const coverTypeGroupValueMap: Record<string, string[]> = {
    "group:PhotoCover": [
        "PhotoCover"
    ],
    "group:PaddedCover": [
        "PaddedCover"
    ],
    "group:CutOut": [
        "Circle", "Rectangle", "Circular", "Rectangular",
        "2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026"
    ],
    "group:Linen or Leather": [
        "01103", "01105", "01203", "01303", "01304", "01305", "01401", "03101", "03301"
    ]
};

export function getOtherConditionDropdownOptions() {
    return [
        {
            variableName: "ArticleCode"
        },
        {
            variableName: "ArticleType",
            evaluationValues: [
                "AcrylicPhotoBlock",
                "Aluminium",
                "AluminiumButler",
                "Calendar",
                "Canvas",
                "Canvas4cm",
                "Cushion",
                "CutoutPhotoBook",
                "Forex",
                "GreetingCard",
                "HardCoverPhotoBook",
                "HardPhotoCoverPhotoBook",
                "Jigsaw",
                "LoveMug",
                "MagicMug",
                "Magnet",
                "MomentsPhotoBook",
                "Mug",
                "PaddedPhotoBook",
                "Perspex",
                "Poster",
                "Prints",
                "SoftCoverPhotoBook",
                "WoodenPhotoBlock"
            ]
        },
        {
            variableName: "ChannelName",
            evaluationValues: [
                "albelli.nl",
                "albelli.be",
                "albelli.se",
                "fotoknudsen.no",
                "hofmann.es",
                "hofmann.pt",
                "posterxxl.de",
                "posterxxl.at",
                "b2b.posterxxl.de",
                "api.posterxxl.de",
                "photobox.co.uk",
                "photobox.fr",
                "photobox.ie",
                "photobox.it",
                "photobox.dk",
            ]
        },
        {
            variableName: "DeliveryMethod",
            evaluationValues: [
                "Home",
                "PUDO"
            ]
        },
        {
            variableName: "DeliveryType",
            evaluationValues: [
                "Standard",
                "Express",
                "Fast"
            ]
        },
        {
            variableName: "DestinationCountry"
        },
        {
            variableName: "DestinationPostcode"
        },
        {
            variableName: "ReceiverName"
        }
    ];
}
